import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const ConfirmDialog = ({
  open,
  handleClose,
  title,
  content,
  yesLabel,
  noLabel,
  yesClick,
  noClick,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={noClick || handleClose} color="primary">
          {noLabel}
        </Button>
        <Button onClick={yesClick} color="primary" autoFocus>
          {yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  yesLabel: PropTypes.string,
  noLabel: PropTypes.string,
  yesClick: PropTypes.func.isRequired,
  noClick: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
  yesLabel: "Yes",
  noLabel: "No",
};

export default ConfirmDialog;
